import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { withRouter, useLocation, useHistory } from 'react-router-dom'
import { withTheme } from 'styled-components'
import { Select } from 'antd'
import { Flex, FlexColumn, CardContainer, LightContainer } from '../../Reusable/Container'
import { Text } from '../../Reusable/Text'
import { ErrorAlert } from '../../Reusable/Alert'
import { Image } from '../../Reusable/Image'
import { getBPAccountsWithAccess, toNumberStr, toCurrency } from '../../../Utils/util'
import { Button, TextButton, ImageButton } from '../../Reusable/Button'
import { apiPOSTReq, apiGETDocUrl, getPreSignedS3Url } from '../../../Utils/api'
import { LabeledInput } from '../../Reusable/Input'
import environment from '../../../environment'
import { FromAccountOption } from '../../Reusable/Option'
import AionIcon from '../../../Images/aion-bank-icon.png'
import Diamond from '../../../Images/hya-diamond.png'

const { Option } = Select

const HighYieldInitialDeposit = (props) => {
    const [accounts, setAccounts] = useState([])
    const [tab, setTab] = useState('details')
    const [fromAccount, setFromAccount] = useState()
    const [transferAmount, setTransferAmount] = useState()
    const [errorField, setErrorField] = useState()
    const [errorMessage, setErrorMessage] = useState()
    const [submitLoading, setSubmitLoading] = useState(false)
    const [showAddFundsResult, setShowAddFundsResult] = useState(false)
    const [isComplete, setIsComplete] = useState(true);

    const { getAccounts, selectedAccount, setShowAddFundsModal, setShowCalculator } = props

    useEffect(() => {
        var Accounts = getBPAccountsWithAccess("Payments", { permType: "manage", getActiveAccounts: true }) || []
        Accounts = Accounts.filter(acc => acc.accountId !== selectedAccount?.accountId)
        if (Accounts?.length === 1) setFromAccount(Accounts[0])
    }, [])

    const getAccountOptions = (id) => {
        var Accounts = getBPAccountsWithAccess("Payments", { permType: "manage", getActiveAccounts: true }) || []
        Accounts = Accounts.filter(acc => acc.accountId !== selectedAccount.accountId)
        Accounts = Accounts.filter(acc => acc.accountType !== "ACCOUNTS_RECEIVABLE")

        var options = []
        Accounts.forEach(account => {
            options.push(
                <Option key={account.accountId} id={id} value={account.accountId} style={{ backgroundColor: "transparent" }}>
                    <FromAccountOption account={account} />
                </Option>
            )
        })
        return options
    }

    const handleSelectAccount = (value, option) => {
        var Accounts = getBPAccountsWithAccess("Payments", { permType: "manage", getActiveAccounts: true })
        var account = Accounts.find(a => a.accountId === value)
        setFromAccount(account)
        setErrorField(null)
        setErrorMessage(null)
    }

    var fromOptions = getAccountOptions("fromAccount")

    const confirmPayment = () => {
        if(!fromAccount) {
            setErrorField("fromAccount")
            setErrorMessage("From account is required")
            return
        }

        if(!transferAmount) {
            setErrorField("transferAmount")
            setErrorMessage("Transfer amount is required")
            return
        }

        const transferMax = fromAccount && Math.max(0, fromAccount.availableBalance);

        if (transferAmount > transferMax) {
            setErrorField("transferAmount")
            setErrorMessage("The transfer amount exceeds the available balance in your account")
            return
        }

        setErrorField(null)
        setErrorMessage(null)

        var body = {
            "fromAccountId": fromAccount.accountId || "",
            "toAccountId": selectedAccount?.accountId || "",
            "FromAccountNumber": fromAccount.accountNumber,
            "ToAccountNumber": selectedAccount?.accountNumber,
            "amount": toNumberStr(transferAmount),
            "amountStr": toNumberStr(transferAmount),
            "operationType": "user",
            "userNote": "High Yield Deposit",
            "purpose": "High Yield Deposit",
            "remittanceInfo": "High Yield Deposit"
        }

        setSubmitLoading(true)
        console.log("HYA confirmPayment body", body)
        apiPOSTReq(`${environment.bbBaseUrl}/bb/xfer`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp
                if (data.result) {
                    console.log("HYA confirmPayment resp", resp)
                    setShowAddFundsResult(true)

                    setTimeout(() => {
                        getAccounts()
                    }, 3000);
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR HYA confirmPayment", error, err, resp)
                ErrorAlert({ description: error.message })
            } finally {
                setSubmitLoading(false)
            }
        })
    }

    const checkTransferAmount = () => {
        const { transferAmount, fromAccount } = this.state

        const transferMax = fromAccount && Math.max(0, fromAccount.availableBalance);

        if (transferAmount > transferMax) {
            this.setState({ errorField: 'transferAmount', errorMessage: "The transfer amount exceeds the available balance in your account" })
        } else {
            this.setState({ errorField: null, errorMessage: null })
        }
    }

    const nickNameMaxLen = 15
    var fromAccountNickName = `${(fromAccount?.nickName || "").trim().substr(0, nickNameMaxLen)}${(fromAccount?.nickName || "").trim().length > nickNameMaxLen ? "..." : ""}`

    return (
        <FlexColumn style={{ width: '100%', height: "100%", marginTop: 12, paddingLeft: 12 }} start>

            <Flex fullWidth between style={{ padding: '0 24px', marginBottom: 48 }} fullHeight>
                <CardContainer fullWidth fullHeight>
                    {
                        !showAddFundsResult ?
                            <FlexColumn start centerH fullHeight gap='24px' style={{ paddingTop: 96 }}>
                                <Image src={Diamond} height="56px" width="56px" />
                                <Text size="24px" weight="700" color="#000">
                                    Getting started with your High Yield Account
                                </Text>
                                <Text size="16px" color="#8181A0">
                                    Move money and start earning right away
                                </Text>

                                <LightContainer style={{ width: 850 }}>
                                    <FlexColumn start center fullWidth>
                                        <Text size="20px" weight="600" color="#000">
                                            Add funds
                                        </Text>
                                        <Text size="16px" color="#8181A0" margin="8px 0 16px">
                                            Instantly transfer from your Aion account. No fees.
                                        </Text>

                                        <Flex start gap='24px'>
                                            <LabeledInput
                                                label="From account"
                                                type="select"
                                                id="fromAccount"
                                                key="fromAccount"
                                                placeholder="Select account"
                                                width='380px'
                                                value={fromAccount && <Flex between centerHorizontally style={{ height: 30 }}>
                                                    <Text><img width='16px' height='16px' src={AionIcon} style={{ marginRight: 8, marginBottom: 2 }} />{`${fromAccountNickName} • ${fromAccount.mask}`}</Text>
                                                    <Text size='14px' lightText style={{ marginLeft: 8 }}>${toCurrency(fromAccount.availableBalance)}</Text>
                                                </Flex>}
                                                autoFocus
                                                onChange={handleSelectAccount}
                                                error={errorField === "fromAccount"}
                                                errorMessage={errorMessage}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                className='parent-node-select-dropdown-menu'
                                            >
                                                {fromOptions}
                                            </LabeledInput>

                                            <LabeledInput
                                                type="number"
                                                label="Transfer amount"
                                                id="transferAmount"
                                                key="transferAmount"
                                                className="no-left-padding"
                                                placeholder="Enter transfer amount"
                                                width='380px'
                                                min={0}
                                                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                value={transferAmount}
                                                onChange={(value) => setTransferAmount(value)}
                                                error={errorField === "transferAmount"}
                                                errorMessage={errorMessage}
                                            />
                                        </Flex>

                                        <FlexColumn start centerH gap="24px" style={{ marginTop: 16 }}>
                                            <Button text="Add funds" solid width="115px" onClick={confirmPayment} loading={submitLoading} />

                                            <TextButton size="16px" text='Deposit funds from an external account' weight='400' underline onClick={() => setShowAddFundsModal(true)} />

                                            <TextButton size="16px" text='Learn more how this account works' weight='400' underline onClick={() => setShowCalculator(true)} />
                                        </FlexColumn>
                                    </FlexColumn>
                                </LightContainer>
                            </FlexColumn>
                            :
                            <>
                                <FlexColumn center fullHeight gap='24px'>
                                    {/* Circle loader with conditional "load-complete" class */}
                                    <div className={`circle-loader ${isComplete ? "load-complete" : ""}`}>
                                        {/* Checkmark only visible when loading is complete */}
                                        <div className={`checkmark ${isComplete ? "draw" : ""}`} />
                                    </div>

                                    <FlexColumn start center style={{ marginBottom: 120 }}>
                                        <Text size="20px" weight='600' margin="0 0 12px">${toCurrency(transferAmount)} deposited</Text>
                                        <Text center margin="0 0 0">This amount will start earning interest daily. Interest earned will be<br />credited by the 10th calendar day of the following month.</Text>
                                    </FlexColumn>
                                </FlexColumn>
                            </>
                    }
                </CardContainer>
            </Flex>

        </FlexColumn>
    )
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        bankingStore: state.bankingAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(HighYieldInitialDeposit)))